import React from 'react';
import PropTypes from 'prop-types';

export const ResearchPaper = ({ citation, authconf, year, links }) => {
    return (
        <div className="border p-3 mb-3 rounded">
            <div className="d-flex flex-wrap">
                <span style={{ fontWeight: 550, marginRight: "8px" }} dangerouslySetInnerHTML={{ __html: citation }}/>
                {links.paper && (
                    <a
                        href={links.paper}
                        className="btn btn-outline-primary rounded-pill me-2"
                        style={{ padding: "6px 6px", lineHeight: "1", display: "flex" }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <small style={{ fontSize: "0.7rem" }}>Paper</small>
                    </a>
                )}
                {links.poster && (
                    <a
                        href={links.poster}
                        className="btn btn-outline-secondary rounded-pill me-2"
                        style={{ padding: "6px 6px", lineHeight: "1", display: "flex" }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <small style={{ fontSize: "0.7rem" }}>Poster</small>
                    </a>
                )}
                {links.video && (
                    <a
                        href={links.video}
                        className="btn btn-outline-success rounded-pill me-2"
                        style={{ padding: "6px 6px", lineHeight: "1", display: "flex" }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <small style={{ fontSize: "0.7rem" }}>Video</small>
                    </a>
                )}
                {links.code && (
                    <a
                        href={links.code}
                        className="btn btn-outline-warning rounded-pill me-2"
                        style={{ padding: "6px 6px", lineHeight: "1", display: "flex" }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <small style={{ fontSize: "0.7rem" }}>Code</small>
                    </a>
                )}
                {links.slides && (
                    <a
                        href={links.slides}
                        className="btn btn-outline-info rounded-pill me-2"
                        style={{ padding: "6px 6px", lineHeight: "1", display: "flex" }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <small style={{ fontSize: "0.7rem" }}>Slides</small>
                    </a>
                )}
            </div>
            <span style={{ fontSize: "0.9rem" }} dangerouslySetInnerHTML={{ __html: authconf }} />
        </div>
    );
};
